import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

import { SPACE } from 'Components/Theme';
import { SolutionGroups as SolutionGroupsView } from 'Components/MockExam';
import { RButton, Modal, Box } from 'Components/Base';
import { getBanner, isBannerCTAEnabled } from 'Domain';

import SolutionDetails from '../../Components/SolutionDetails';
import { Banner } from '../../Components';

const renderActionRow = (row, totalRows) => (
  <Modal
    borderless
    button={
      <RButton
        title="ดูเฉลย"
        icon="play_circle_filled"
        iconRight
        iconStyle={{ fontSize: '1.5em' }}
      />
    }
    content={toggle => (
      <SolutionDetails
        onBackClick={toggle}
        examId={row.examId}
        examCardId={row.examCardId}
        sectionIndex={row.sectionIndex}
        questionIndex={row.questionIndex}
        itemNumber={row.itemNumber}
      />
    )}
  />
);

export default class SolutionGroups extends Component {
  static propTypes = {
    sections: PropTypes.array,
  };
  static defaultProps = {
    sections: [],
  };

  handleBannerClick = (event, subjectCode, subjectName) => {
    try {
      ReactGA.event({
        category: 'CAMPAIGN_MF_2562-01',
        action: 'Tab3 Banner Click',
        label: `${subjectName}:${subjectCode}`,
      });
    } catch (err) {
      console.log('ga error:', err);
    }
    const { href, search } = event.currentTarget;
  };

  renderMFBanner = () => {
    const { subjectCode, subjectName } = this.props;
    const { image: bannerImage, link: bannerLink } = getBanner(subjectCode, 'tab3');

    return isBannerCTAEnabled && bannerImage && bannerLink ? (
      <Box mt={SPACE.large}>
        <Banner
          link={bannerLink}
          imageSrc={bannerImage}
          subjectName={subjectName}
          onBannerClick={event => this.handleBannerClick(event, subjectCode, subjectName)}
        />
      </Box>
    ) : null;
  };

  render() {
    const { sections } = this.props;
    return (
      <Fragment>
        {this.renderMFBanner()}
        <SolutionGroupsView sections={sections} renderActionRow={renderActionRow} />
      </Fragment>
    );
  }
}
